import { gql } from '@apollo/client'

export default gql`
  mutation RandomBattlePassPrize($input: RandomBattlePassPrizeInput) {
    randomBattlePassPrize(input: $input) {
      prizeAssetName
      qty
    }
  }
`
